module.exports = "<div class=\"time-wrapper\"\r\n     [ngClass]=\"{'time-wrapper-invalid': !isValid}\">\r\n    <input type=\"text\" class=\"{{timeCssClass}}\"\r\n           [ngModel]=\"_timeString\"\r\n           (keyup)=\"onChange($event)\"/>\r\n    <div class=\"top-bottom\">\r\n        <button class=\"top\" (click)=\"onClick(1)\"></button>\r\n        <button class=\"bottom\" (click)=\"onClick(2)\"></button>\r\n    </div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/timepicker/timepicker.component.html
// module id = ./src/app/shared/timepicker/timepicker.component.html
// module chunks = main